import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCustomizedTripsDtlbannersec } from "../services/CustomizedTripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const CustomizedTripsDtlbannersec = () => {
  const { id,type } = useParams();
  const [CustomizedTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCustomizedTripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setCustomizedTripsDtl(res.data[0]); 
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  // NEW: destination count from covered_place
const destinationCount = CustomizedTripsDtl?.covered_place
  ? CustomizedTripsDtl.covered_place
      .split(",")
      .map(p => p.trim())
      .filter(Boolean).length
  : 0;


  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!CustomizedTripsDtl) return <p className="text-center py-10">No CustomizedTripsDtl found</p>;

  return (

      <section className="relative bg-slate-900">
          {/* Top Buttons */}
          <div className="absolute left-0 right-0 top-0 z-10 flex items-center justify-between px-4 pt-4 md:px-4 md:pt-6">
            {/* Back Button */}
        <a href="/customizedtrips">  
            <button className="justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-10 group flex items-center gap-1 rounded-full border-white/30 bg-black/40 px-3 py-1.5 text-white backdrop-blur-lg hover:bg-black/60 hover:text-white md:px-4 md:py-2">
              {/* SVG Path adjusted */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1 md:h-4 md:w-4"
              >
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
              </svg>
              <span className="text-sm font-medium md:text-sm">Back</span>
            </button>
          </a>
            {/* Share Button */}
            <a href="https://wa.me/919090403075" className="justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-10 flex items-center gap-1.5 rounded-full border-white/30 bg-black/40 px-3 py-1.5 text-white backdrop-blur-lg hover:bg-black/60 hover:text-white md:px-4 md:py-2">
              {/* SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-share2 h-4 w-4 md:h-4 md:w-4"
              >
                <circle cx={18} cy={5} r={3} />
                <circle cx={6} cy={12} r={3} />
                <circle cx={18} cy={19} r={3} />
                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
              </svg>
              <span className="text-sm font-medium md:text-sm">Share</span>
            </a>
          </div>
          {/* Header Image & Overlay */}
          <div className="relative h-[32vh] min-h-[240px] w-full md:h-[50vh] lg:h-[60vh]">
            <img
              alt="Family Adventure in Switzerland"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent",
              }}
              src={
              CustomizedTripsDtl?.images
                ? `${API_BASE}${CustomizedTripsDtl.images}`
                : `${API_BASE}default.jpg`
            }
            onError={(e) => {
              e.currentTarget.src = `${API_BASE}default.jpg`;
            }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-slate-900/30" />
          </div>
          {/* Header Text & Tags */}
          <div className="container absolute bottom-0 left-0 right-0 mx-auto px-4 py-4 md:px-4 md:py-10 lg:py-12 text-white">
            {/* Tags */}
            <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-3">
              {/* Tag 1 */}
              <div className="inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-none bg-primary text-white px-2 py-0.5 md:px-2 font-medium text-xs md:text-xs">
                {type == 1 ? "International" : "Domestic"}
              </div>
              {/* Tag 2 */}
              <div className="flex items-center bg-black/30 rounded-full px-2 py-0.5 md:px-2.5 md:py-1 text-white/90">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star mr-1 h-3 w-3 md:mr-1 md:h-3.5 md:w-3.5"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <span className="text-xs md:text-xs font-medium">4.8 (20+)</span>
              </div>
            </div>
            {/* Title */}
            <h1 className="mt-2 text-xl font-bold leading-tight md:mt-3 md:text-3xl lg:text-4xl drop-shadow-sm">
              {CustomizedTripsDtl.name}
            </h1>
            {/* Info */}
            <div className="mt-2.5 flex flex-wrap items-center gap-x-3 gap-y-1.5 md:mt-6 md:gap-x-6 md:gap-y-3">
              {/* Duration */}
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-clock h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <circle cx={12} cy={12} r={10} />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <span className="text-sm md:text-base">{CustomizedTripsDtl.no_of_days} Days</span>
              </div>
              {/* Number of People */}
          {CustomizedTripsDtl.spots && Number(CustomizedTripsDtl.spots) !== 0 && (
               <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-users h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx={9} cy={7} r={4} />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <span className="text-sm md:text-base">{CustomizedTripsDtl.spots} People</span>
              </div>
          )}
              {/* Destinations */}
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
                <span className="text-sm md:text-base">{destinationCount} {destinationCount === 1 ? "Destination" : "Destinations"}</span>
              </div>
            </div>
          </div>
        </section>

    

 
  );
};

export default CustomizedTripsDtlbannersec;
